@if (image?.imageUrl) {
  <div class="meteo-image">
    <img class="meteo-image__img"
      [src]="currentImageUrl"
      [alt]="image?.caption || ''">
    <!-- Quellen-Sidebar (FILE/DOC): wählt, aus welcher Quelle die Grafik-Werte kommen.
         Nur die Lokalzeit-Bilder (die mit Abschnitten) haben sie; die reinen Grafik-Karten
         zeigen an derselben Stelle ihre eigenen Knöpfe – siehe zeigtKartenBedienung(). -->
    @if (zeigtQuellenwahl()) {
      <nav class="meteo-source-sidebar">
        @for (btn of sourceButtons; track btn.source) {
          <button type="button"
            class="meteo-source-sidebar__item"
            [class.meteo-source-sidebar__item--active]="activeSource === btn.source"
            (click)="onSourceClick(btn.source)">
            {{ btn.label }}
          </button>
        }
      </nav>
    }
    <!-- Sidebar der Ansichten/Tageszeiten, links über dem Bild. Klickbar, Aktion noch nicht verdrahtet. -->
    @if (image?.sections?.length) {
      <nav class="meteo-sidebar">
        @for (section of image?.sections; track $index) {
          <button type="button"
            class="meteo-sidebar__item"
            [class.meteo-sidebar__item--active]="activeSectionId === (section.id ?? section.title)"
            (click)="onSectionClick(section)">
            {{ section.title }}
          </button>
        }
      </nav>
    }
    <!-- Bedienelemente der Karte selbst. Nur auf den reinen Grafik-Karten: die
         Lokalzeit-Bilder tragen oben links ihre Sidebars und würden sich überdecken.
         Die großen Buttons oben auf der Seite bleiben unberührt; das hier ist die
         kleine Variante je Karte, nur mit Icon. -->
    @if (zeigtKartenBedienung()) {
      @if (hatWetterIcons() && zeigtSyncSchalter()) {
        <!-- Sync: überträgt das zuletzt bearbeitete Wetter-Symbol auf alle anderen
             Symbole DIESER Karte. Ausschalten stellt den Stand von vor dem
             Einschalten wieder her. -->
        <button type="button"
          class="meteo-switch"
          role="switch"
          [class.meteo-switch--on]="syncAktiv"
          [attr.aria-checked]="syncAktiv"
          [disabled]="!syncMoeglich()"
          [title]="syncTitel()"
          (click)="onSyncToggle()">
          <span class="meteo-switch__track"><span class="meteo-switch__knob"></span></span>
          <span class="meteo-switch__text">Sync</span>
        </button>
      }
      @if (zeigtTempSchalter()) {
        <!-- Temp: nur "feine" und "sehr feine Unterteilung". An = die Temperaturen dieser
             Karte gehen in die KI-Anfrage, aus = nicht – unabhängig von den gelben Haken. -->
        <button type="button"
          class="meteo-switch meteo-switch--zweite"
          role="switch"
          [class.meteo-switch--on]="tempAktiv"
          [attr.aria-checked]="tempAktiv"
          [title]="tempTitel()"
          (click)="onTempToggle()">
          <span class="meteo-switch__track"><span class="meteo-switch__knob"></span></span>
          <span class="meteo-switch__text">Temp</span>
        </button>
      }
      @if (zeigtWindSchalter()) {
        <!-- Wind: nur die Wind-Karte. Ein Sammelschalter für die gelben Kästchen der
             regionalen Wind-Boxen: an = alle anhaken, aus = alle abhaken; "NRW ganz" bleibt
             unberührt. Er steht auf an, wenn alle angehakt sind – ein einzeln abgewähltes
             Kästchen schaltet ihn auf aus. Die Wind-Karte hat weder Sync noch Temp, der
             Schalter sitzt deshalb oben links auf der Höhe des Sync der anderen Karten. -->
        <button type="button"
          class="meteo-switch meteo-switch--wind"
          role="switch"
          [class.meteo-switch--on]="windAktiv"
          [attr.aria-checked]="windAktiv"
          [title]="windTitel()"
          (click)="onWindToggle()">
          <span class="meteo-switch__track"><span class="meteo-switch__knob"></span></span>
          <span class="meteo-switch__text">Wind</span>
        </button>
      }
      <div class="meteo-actions">
        <button type="button" class="meteo-action"
          title="MSWR-MOS laden (nur diese Karte)"
          aria-label="MSWR-MOS laden"
          (click)="onKarteLaden()">
          <mat-icon>download</mat-icon>
        </button>
        <button type="button" class="meteo-action"
          title="leeren (nur diese Karte)"
          aria-label="leeren"
          (click)="onKarteLeeren()">
          <mat-icon>highlight_off</mat-icon>
        </button>
      </div>
    }
    <!-- Statische Beschriftungen (z.B. Wochentags-Kopfzeilen der Prognose) -->
    @for (label of activeLabels; track $index) {
      <div class="meteo-label" [ngStyle]="labelStyle(label)">{{ labelText(label) }}</div>
    }

    <!-- Verbindungs-Pfeile zwischen angehakten Boxen (Oktober 2026): ein SVG im Referenzraum,
         unter den Boxen und ohne Mausereignisse – nur die Trefferlinien nehmen Klicks an;
         die Spitze ist ein Marker je Karte. Damit ein Pfeil hinter einer Box nicht verloren
         geht, zeichnet ein zweites, durchscheinendes SVG nach der Box-Schleife dieselben
         Linien noch einmal über die Boxen (.meteo-pfeile--durchschein). -->
    @if (pfeilLinien().length || pfeilEntwurf()) {
      <svg class="meteo-pfeile" [attr.viewBox]="'0 0 ' + REF_WIDTH + ' ' + REF_HEIGHT"
        preserveAspectRatio="none" aria-hidden="true">
        <defs>
          <marker [attr.id]="pfeilMarkerId" markerUnits="userSpaceOnUse" markerWidth="40" markerHeight="40"
            refX="38" refY="20" orient="auto">
            <path class="meteo-pfeile__spitze" d="M0,4 L38,20 L0,36 Z"></path>
          </marker>
        </defs>
        @for (linie of pfeilLinien(); track linie.von) {
          <line class="meteo-pfeile__halo" [attr.x1]="linie.x1" [attr.y1]="linie.y1"
            [attr.x2]="linie.x2" [attr.y2]="linie.y2"></line>
          <line class="meteo-pfeile__linie" [attr.x1]="linie.x1" [attr.y1]="linie.y1"
            [attr.x2]="linie.x2" [attr.y2]="linie.y2"
            [class.meteo-pfeile__linie--ausgewaehlt]="pfeilAusgewaehlt === linie.von"
            [attr.marker-end]="'url(#' + pfeilMarkerId + ')'"></line>
          <!-- breite, unsichtbare Trefferlinie: Klick wählt den Pfeil aus (zeigt sein X) -->
          <line class="meteo-pfeile__treffer" [attr.x1]="linie.x1" [attr.y1]="linie.y1"
            [attr.x2]="linie.x2" [attr.y2]="linie.y2"
            (click)="onPfeilKlick($event, linie.von)"></line>
        }
        @if (pfeilEntwurf(); as entwurf) {
          <line class="meteo-pfeile__linie meteo-pfeile__linie--entwurf" [attr.x1]="entwurf.x1" [attr.y1]="entwurf.y1"
            [attr.x2]="entwurf.x2" [attr.y2]="entwurf.y2"
            [attr.marker-end]="'url(#' + pfeilMarkerId + ')'"></line>
        }
      </svg>
      <!-- Das X in der Mitte des ausgewählten Pfeils: entfernt ihn -->
      @for (linie of pfeilLinien(); track linie.von) {
        @if (pfeilAusgewaehlt === linie.von) {
          <button type="button" class="meteo-pfeile__loeschen" [ngStyle]="loeschKnopfStil(linie)"
            title="Pfeil entfernen" aria-label="Pfeil entfernen"
            (click)="loeschePfeil($event, linie.von)">×</button>
        }
      }
    }

    <!-- Interaktive Overlay-Boxen des aktiven Abschnitts (Städte bzw. Prognosespalten). -->
    @for (box of activeBoxes; track trackBox($index, box)) {
      @if (isWind(box)) {
        <!-- Wind-Box: oben Mittelwind, unten Böen, rechts der drehbare Windpfeil.
             Der Pfeil dreht sich nach dem Zahlenwert in seiner Mitte (1 = Wind aus Süd, je 22,5 Grad im Uhrzeigersinn; 17/18 = wechselnd). -->
        <div
          class="meteo-box meteo-box--wind"
          [attr.data-box-id]="box.id"
          [class.meteo-box--hover]="hoveredId === box.id"
          [class.meteo-box--editing]="editingId === box.id"
          [ngStyle]="boxStyle(box)"
          [style.outline-color]="outlineColor(box)"
          [style.box-shadow]="glowShadow(box)"
          (mouseenter)="onBoxEnter(box)"
          (mouseleave)="onBoxLeave()">
          @if (box.region) {
            <span class="meteo-box__tooltip">{{ box.region }}</span>
          }
          <!-- linke Spalte: zwei Kästen untereinander -->
          <span class="meteo-box__stack">
            <span class="meteo-box__cell meteo-box__cell--stacked"
              title="Mittelwind"
              (click)="startEdit(box, windInput)">
              <input #windInput
                (focus)="startEdit(box, windInput)"
                class="meteo-box__input"
                inputmode="numeric"
                [value]="numericPart(box)"
                [style.width]="inputWidth(box)"
                [readonly]="editingId !== box.id"
                (keydown)="onKeydown($event)"
                (input)="onInput(box, windInput)"
                (blur)="stopEdit()"
                (keydown.enter)="stopEdit()"
                (keydown.escape)="stopEdit()">
            </span>
            <span class="meteo-box__cell meteo-box__cell--stacked meteo-box__cell--gust"
              title="Böen"
              (click)="startEdit(box, gustInput)">
              <input #gustInput
                (focus)="startEdit(box, gustInput)"
                class="meteo-box__input"
                inputmode="numeric"
                [value]="gustPart(box)"
                [style.width]="gustInputWidth(box)"
                [readonly]="editingId !== box.id"
                (keydown)="onKeydown($event)"
                (input)="onGustInput(box, gustInput)"
                (blur)="stopEdit()"
                (keydown.enter)="stopEdit()"
                (keydown.escape)="stopEdit()">
            </span>
          </span>
          <!-- rechte Spalte: Windpfeil mit Richtungsfeld in der Mitte -->
          <!-- Doppelklick wirkt auf der ganzen Fläche: Pfeil wie Zahl öffnen das Feld. -->
          <span class="meteo-box__wind"
            [attr.title]="windDirectionName(box)"
            (click)="startEdit(box, dirInput)">
            @if (isRotatingWind(box)) {
              <!-- Wert 17 oder 18: wechselnde Richtungen – ein Pfeil, der einmal im Kreis läuft -->
              <svg class="meteo-box__wind-arrow meteo-box__wind-arrow--turn"
                viewBox="0 0 100 100">
                <path d="M60.5 17.7 A34 34 0 1 1 39.5 17.7"
                  fill="none" stroke-width="12" stroke-linecap="butt"></path>
                <path d="M52.8 13.3 L42.6 27.2 L36.4 8.2 Z"></path>
              </svg>
            } @else {
              <svg class="meteo-box__wind-arrow"
                viewBox="0 0 100 100"
                [style.transform]="'rotate(' + windAngle(box) + 'deg)'">
                <path d="M50 3 L80 45 L61 45 L61 97 L39 97 L39 45 L20 45 Z"></path>
              </svg>
            }
            <!-- Kreis hinter der Zahl, damit sie auf dem Pfeil lesbar bleibt -->
            <span class="meteo-box__wind-badge">
              <input #dirInput
                (focus)="startEdit(box, dirInput)"
                class="meteo-box__input meteo-box__wind-input"
                inputmode="numeric"
                [value]="dirPart(box)"
                [style.width]="dirInputWidth(box)"
                [readonly]="editingId !== box.id"
                (click)="startEdit(box, dirInput)"
                (keydown)="onKeydown($event)"
                (input)="onDirInput(box, dirInput)"
                (blur)="stopEdit()"
                (keydown.enter)="stopEdit()"
                (keydown.escape)="stopEdit()">
            </span>
          </span>
          <!-- Gelber Umschalter der NRW-Wind-Boxen (Oktober 2026): nur angehakt geht der Wind
               in die KI-Anfrage. Dieselbe Mechanik wie bei den Symbol-Boxen. -->
          @if (zeigtPfeilGriff(box)) {
            <span class="meteo-box__pfeil" [ngStyle]="pfeilGriffStil(box)"
              [class.meteo-box__pfeil--verbunden]="hatPfeil(box)"
              [class.meteo-box__pfeil--aktiv]="ziehtPfeilVon(box)"
              [attr.title]="pfeilTitel(box)"
              (pointerdown)="onPfeilStart($event, box)"
              (click)="$event.stopPropagation()"></span>
          }
          <!-- Reihenfolge-Nummer (blauer Kreis unten links): nur bei angehaktem gelben Kästchen -->
          @if (reihenNummer(box); as nummer) {
            <span class="meteo-box__reihe" [ngStyle]="reiheStil(box)"
              [attr.title]="reiheTitel(nummer)"><span class="meteo-box__reihe-zahl">{{ nummer }}</span></span>
          }
          @for (toggle of togglesFor(box); track trackToggle($index, toggle)) {
            <button type="button"
              class="meteo-box__toggle"
              [class.meteo-box__toggle--bottom]="toggle.position === 'bottom-right'"
              [class.meteo-box__toggle--active]="isToggleActive(box, toggle)"
              [style.background-color]="toggle.color"
              [ngStyle]="toggleStyle(box, toggle)"
              [attr.aria-pressed]="isToggleActive(box, toggle)"
              (click)="onToggleClick($event, box, toggle)">
              @if (isToggleActive(box, toggle)) {
                <span class="meteo-box__toggle-symbol">{{ toggle.symbol }}</span>
              }
            </button>
          }
        </div>
      } @else if (isTempIcon(box)) {
        <!-- Kombi-Box: links die Temperatur, rechts das Wetter-Symbol – beide editierbar. -->
        <div
          class="meteo-box meteo-box--combo"
          [attr.data-box-id]="box.id"
          [class.meteo-box--hover]="hoveredId === box.id"
          [class.meteo-box--editing]="editingId === box.id"
          [ngStyle]="boxStyle(box)"
          [style.outline-color]="outlineColor(box)"
          [style.box-shadow]="glowShadow(box)"
          (mouseenter)="onBoxEnter(box)"
          (mouseleave)="onBoxLeave()">
          @if (box.region) {
            <span class="meteo-box__tooltip">{{ box.region }}</span>
          }
          <!-- linke Zelle: Temperatur -->
          <span class="meteo-box__cell"
            [style.background-color]="tempCellBackground(box)"
            (click)="startEdit(box, tempInput)">
            <input #tempInput
                (focus)="startEdit(box, tempInput)"
              class="meteo-box__input"
              inputmode="numeric"
              [value]="numericPart(box)"
              [style.width]="inputWidth(box)"
              [readonly]="editingId !== box.id"
              (keydown)="onKeydown($event)"
              (input)="onInput(box, tempInput)"
              (blur)="stopEdit()"
              (keydown.enter)="stopEdit()"
              (keydown.escape)="stopEdit()">
            <span class="meteo-box__unit">{{ unit(box) }}</span>
          </span>
          <!-- rechte Zelle: Wetter-Symbol -->
          <span class="meteo-box__cell meteo-box__cell--icon"
            [style.background-image]="iconCellImage(box)"
            (click)="startEdit(box, iconInput)">
            <span class="meteo-box__badge">
              <input #iconInput
                (focus)="startEdit(box, iconInput)"
                class="meteo-box__input meteo-box__input--icon"
                inputmode="numeric"
                [value]="iconPart(box)"
                [style.width]="iconInputWidth(box)"
                [readonly]="editingId !== box.id"
                (keydown)="onKeydown($event)"
                (input)="onIconInput(box, iconInput)"
                (blur)="stopEdit()"
                (keydown.enter)="stopEdit()"
                (keydown.escape)="stopEdit()">
            </span>
          </span>
          @if (zeigtPfeilGriff(box)) {
            <span class="meteo-box__pfeil" [ngStyle]="pfeilGriffStil(box)"
              [class.meteo-box__pfeil--verbunden]="hatPfeil(box)"
              [class.meteo-box__pfeil--aktiv]="ziehtPfeilVon(box)"
              [attr.title]="pfeilTitel(box)"
              (pointerdown)="onPfeilStart($event, box)"
              (click)="$event.stopPropagation()"></span>
          }
          <!-- Reihenfolge-Nummer (blauer Kreis unten links): nur bei angehaktem gelben Kästchen -->
          @if (reihenNummer(box); as nummer) {
            <span class="meteo-box__reihe" [ngStyle]="reiheStil(box)"
              [attr.title]="reiheTitel(nummer)"><span class="meteo-box__reihe-zahl">{{ nummer }}</span></span>
          }
          @for (toggle of togglesFor(box); track trackToggle($index, toggle)) {
            <button type="button"
              class="meteo-box__toggle"
              [class.meteo-box__toggle--bottom]="toggle.position === 'bottom-right'"
              [class.meteo-box__toggle--active]="isToggleActive(box, toggle)"
              [style.background-color]="toggle.color"
              [ngStyle]="toggleStyle(box, toggle)"
              [attr.aria-pressed]="isToggleActive(box, toggle)"
              (click)="onToggleClick($event, box, toggle)">
              @if (isToggleActive(box, toggle)) {
                <span class="meteo-box__toggle-symbol">{{ toggle.symbol }}</span>
              }
            </button>
          }
        </div>
      } @else if (isMaxMinIcon(box)) {
        <!-- Höchst-/Tiefstwert-Box (Samstag, AUSSICHTEN): links zwei Temperaturen übereinander –
             oben der Höchstwert (Hauptwert), darunter der Tiefstwert –, rechts das Wetter-Symbol
             wie bei der Kombi-Box. Jede Zelle färbt sich nach ihrem Wert (Temperatur-Palette). -->
        <div
          class="meteo-box meteo-box--combo meteo-box--maxmin"
          [attr.data-box-id]="box.id"
          [class.meteo-box--hover]="hoveredId === box.id"
          [class.meteo-box--editing]="editingId === box.id"
          [ngStyle]="boxStyle(box)"
          [style.outline-color]="outlineColor(box)"
          [style.box-shadow]="glowShadow(box)"
          (mouseenter)="onBoxEnter(box)"
          (mouseleave)="onBoxLeave()">
          @if (box.region) {
            <span class="meteo-box__tooltip">{{ box.region }}</span>
          }
          <span class="meteo-box__stack meteo-box__stack--temp">
            <!-- oben: Höchstwert -->
            <span class="meteo-box__cell meteo-box__cell--stacked"
              [style.background-color]="tempCellBackground(box)"
              title="Höchstwert"
              (click)="startEdit(box, maxInput)">
              <input #maxInput
                (focus)="startEdit(box, maxInput)"
                class="meteo-box__input"
                inputmode="numeric"
                [value]="numericPart(box)"
                [style.width]="inputWidth(box)"
                [readonly]="editingId !== box.id"
                (keydown)="onKeydown($event)"
                (input)="onInput(box, maxInput)"
                (blur)="stopEdit()"
                (keydown.enter)="stopEdit()"
                (keydown.escape)="stopEdit()">
              <span class="meteo-box__unit">{{ unit(box) }}</span>
            </span>
            <!-- unten: Tiefstwert -->
            <span class="meteo-box__cell meteo-box__cell--stacked meteo-box__cell--min"
              [style.background-color]="minCellBackground(box)"
              title="Tiefstwert"
              (click)="startEdit(box, minInput)">
              <input #minInput
                (focus)="startEdit(box, minInput)"
                class="meteo-box__input"
                inputmode="numeric"
                [value]="minPart(box)"
                [style.width]="minInputWidth(box)"
                [readonly]="editingId !== box.id"
                (keydown)="onKeydown($event)"
                (input)="onMinInput(box, minInput)"
                (blur)="stopEdit()"
                (keydown.enter)="stopEdit()"
                (keydown.escape)="stopEdit()">
              <span class="meteo-box__unit">{{ unit(box) }}</span>
            </span>
          </span>
          <!-- rechte Zelle: Wetter-Symbol -->
          <span class="meteo-box__cell meteo-box__cell--icon"
            [style.background-image]="iconCellImage(box)"
            (click)="startEdit(box, iconInput)">
            <span class="meteo-box__badge">
              <input #iconInput
                (focus)="startEdit(box, iconInput)"
                class="meteo-box__input meteo-box__input--icon"
                inputmode="numeric"
                [value]="iconPart(box)"
                [style.width]="iconInputWidth(box)"
                [readonly]="editingId !== box.id"
                (keydown)="onKeydown($event)"
                (input)="onIconInput(box, iconInput)"
                (blur)="stopEdit()"
                (keydown.enter)="stopEdit()"
                (keydown.escape)="stopEdit()">
            </span>
          </span>
          @if (zeigtPfeilGriff(box)) {
            <span class="meteo-box__pfeil" [ngStyle]="pfeilGriffStil(box)"
              [class.meteo-box__pfeil--verbunden]="hatPfeil(box)"
              [class.meteo-box__pfeil--aktiv]="ziehtPfeilVon(box)"
              [attr.title]="pfeilTitel(box)"
              (pointerdown)="onPfeilStart($event, box)"
              (click)="$event.stopPropagation()"></span>
          }
          @if (reihenNummer(box); as nummer) {
            <span class="meteo-box__reihe" [ngStyle]="reiheStil(box)"
              [attr.title]="reiheTitel(nummer)"><span class="meteo-box__reihe-zahl">{{ nummer }}</span></span>
          }
          @for (toggle of togglesFor(box); track trackToggle($index, toggle)) {
            <button type="button"
              class="meteo-box__toggle"
              [class.meteo-box__toggle--bottom]="toggle.position === 'bottom-right'"
              [class.meteo-box__toggle--active]="isToggleActive(box, toggle)"
              [style.background-color]="toggle.color"
              [ngStyle]="toggleStyle(box, toggle)"
              [attr.aria-pressed]="isToggleActive(box, toggle)"
              (click)="onToggleClick($event, box, toggle)">
              @if (isToggleActive(box, toggle)) {
                <span class="meteo-box__toggle-symbol">{{ toggle.symbol }}</span>
              }
            </button>
          }
        </div>
      } @else {
      <div
        class="meteo-box"
        [attr.data-box-id]="box.id"
        [class.meteo-box--icon]="isIconBox(box)"
        [class.meteo-box--danger]="isDangerBox(box)"
        [class.meteo-box--hover]="hoveredId === box.id"
        [class.meteo-box--editing]="editingId === box.id"
        [ngStyle]="boxStyle(box)"
        [style.outline-color]="outlineColor(box)"
        [style.background-image]="iconBgImage(box)"
        [style.background-color]="boxBackground(box)"
        [style.box-shadow]="glowShadow(box)"
        (click)="startEdit(box, boxInput)"
        (mouseenter)="onBoxEnter(box)"
        (mouseleave)="onBoxLeave()">
        @if (box.title) {
          <span class="meteo-box__title">{{ box.title }}</span>
        }
        <!-- Regions-Hinweis: liegt immer im DOM, Sichtbarkeit und Verzögerung macht CSS -->
        @if (box.region) {
          <span class="meteo-box__tooltip">{{ box.region }}</span>
        }
        <!-- Bei Symbol-Boxen liegt die Zahl in einem Kreis, damit sie auf dem Icon lesbar bleibt -->
        <span class="meteo-box__valuewrap" [class.meteo-box__badge]="isIconBox(box)">
          <input #boxInput
                (focus)="startEdit(box, boxInput)"
            class="meteo-box__input"
            inputmode="numeric"
            [value]="numericPart(box)"
            [style.width]="inputWidth(box)"
            [readonly]="editingId !== box.id"
            (keydown)="onKeydown($event)"
            (input)="onInput(box, boxInput)"
            (blur)="stopEdit()"
            (keydown.enter)="stopEdit()"
            (keydown.escape)="stopEdit()">
        </span>
        @if (unit(box)) {
          <span class="meteo-box__unit">{{ unit(box) }}</span>
        }
        <!-- Kleine Umschalter rechts an der Box: farbiger Kasten immer sichtbar,
             Klick blendet das Symbol (z.B. "!" / "X") ein und aus. onToggleClick
             stoppt die Propagation, damit der Klick nicht die Box zum Bearbeiten
             öffnet. -->
        @if (zeigtPfeilGriff(box)) {
          <span class="meteo-box__pfeil" [ngStyle]="pfeilGriffStil(box)"
            [class.meteo-box__pfeil--verbunden]="hatPfeil(box)"
            [class.meteo-box__pfeil--aktiv]="ziehtPfeilVon(box)"
            [attr.title]="pfeilTitel(box)"
            (pointerdown)="onPfeilStart($event, box)"
            (click)="$event.stopPropagation()"></span>
        }
        <!-- Reihenfolge-Nummer (blauer Kreis unten links): nur bei angehaktem gelben Kästchen -->
        @if (reihenNummer(box); as nummer) {
          <span class="meteo-box__reihe" [ngStyle]="reiheStil(box)"
            [attr.title]="reiheTitel(nummer)"><span class="meteo-box__reihe-zahl">{{ nummer }}</span></span>
        }
        @for (toggle of togglesFor(box); track trackToggle($index, toggle)) {
          <button type="button"
            class="meteo-box__toggle"
            [class.meteo-box__toggle--bottom]="toggle.position === 'bottom-right'"
            [class.meteo-box__toggle--active]="isToggleActive(box, toggle)"
            [style.background-color]="toggle.color"
              [ngStyle]="toggleStyle(box, toggle)"
            [attr.aria-pressed]="isToggleActive(box, toggle)"
            (click)="onToggleClick($event, box, toggle)">
            @if (isToggleActive(box, toggle)) {
              <span class="meteo-box__toggle-symbol">{{ toggle.symbol }}</span>
            }
          </button>
        }
      </div>
      }
    }

    <!-- Durchscheinende Kopie der Pfeile ÜBER den Boxen: wo ein Pfeil hinter einer Box
         verläuft, bleibt er so schwach sichtbar. Ohne Trefferlinien und ohne X. -->
    @if (pfeilLinien().length) {
      <svg class="meteo-pfeile meteo-pfeile--durchschein" [attr.viewBox]="'0 0 ' + REF_WIDTH + ' ' + REF_HEIGHT"
        preserveAspectRatio="none" aria-hidden="true">
        @for (linie of pfeilLinien(); track linie.von) {
          <line class="meteo-pfeile__linie" [attr.x1]="linie.x1" [attr.y1]="linie.y1"
            [attr.x2]="linie.x2" [attr.y2]="linie.y2"
            [class.meteo-pfeile__linie--ausgewaehlt]="pfeilAusgewaehlt === linie.von"
            [attr.marker-end]="'url(#' + pfeilMarkerId + ')'"></line>
        }
      </svg>
    }

    <!-- Tendenz: Liniendiagramm-Abschnitt -->
    @if (activeGraph) {
      <app-meteo-line-graph [graph]="activeGraph" [measurementsFile]="activeGraphFile"></app-meteo-line-graph>
    }
  </div>
}